import type { DbClient } from '../../../../lib/db.js';

export type CompanyProfileWithMetaRow = {
  forCompanyId: string;
  byCompanyId: string;
  onBehalfOfCompanyId: string;
  profileType: string;
  data: Record<string, unknown>;
  createdAt: string | null;
  createdByImpersonateId: string | null;
  createdByUserId: string | null;
  createdByCompanyId: string | null;
  createdByApiKeyId: string | null;
  createdByApiKeyLabel: string | null;
  updatedAt: string | null;
  updatedByImpersonateId: string | null;
  updatedByImpersonateName: string | null;
  updatedByUserId: string | null;
  updatedByUserName: string | null;
  updatedByCompanyId: string | null;
  updatedByCompanyName: string | null;
  updatedByApiKeyId: string | null;
  updatedByApiKeyLabel: string | null;
};

const FIELDS = [
  'for_company_id',
  'by_company_id',
  'on_behalf_of_company_id',
  'profile_type',
  'data',
  'created_at',
  'created_by_impersonate_id',
  'created_by_user_id',
  'created_by_company_id',
  'created_by_api_key_id',
  'created_by_api_key_label',
  'updated_at',
  'updated_by_impersonate_id',
  'updated_by_impersonate_name',
  'updated_by_user_id',
  'updated_by_user_name',
  'updated_by_company_id',
  'updated_by_company_name',
  'updated_by_api_key_id',
  'updated_by_api_key_label',
].join(', ');

export async function getCompanyProfileWithMetaByIdsDb(
  db: DbClient,
  params: {
    forCompanyId: string;
    byCompanyId: string;
    onBehalfOfCompanyId: string;
    profileType: string;
  },
): Promise<CompanyProfileWithMetaRow | undefined> {
  const { forCompanyId, byCompanyId, onBehalfOfCompanyId, profileType } =
    params;
  return db.selectOne<CompanyProfileWithMetaRow>(
    {
      tableName: 'companies_service_company_profiles',
      fields: FIELDS,
      where: {
        conditions: [
          'for_company_id = :forCompanyId',
          'by_company_id = :byCompanyId',
          'on_behalf_of_company_id = :onBehalfOfCompanyId',
          'profile_type = :profileType',
        ],
      },
    },
    { forCompanyId, byCompanyId, onBehalfOfCompanyId, profileType },
  );
}
